<template>
  <transition name="fade" mode="out-in">
    <div v-if="!state.verification_id" class="view">
      <i v-if="displayIcon" class="bi bi-telephone icon" />
      <div class="block">
        <h2 v-text="title" />
        <p v-text="text" />
      </div>
      <VForm
        :button="{
          class: 'primary full-size',
          label: 'Finaliser l\’inscription',
          hotDisabled: true,
        }"
        :externalRule="!state.isLoading && state.isValid"
        :callback="sendSMS"
      >
        <template #form-body="{ setFieldError }">
          <div class="input-wrapper">
            <label v-text="$t('form.register.phone')" for="phone" />
            <vue-tel-input
              id="phone"
              v-model="state.phone_number.formatted"
              :required="true"
              :styleClasses="{
                invalid: !state.isValid && state.phoneBlur,
              }"
              @on-input="formatNumber"
              @blur="
                () => {
                  if (!state.isValid) {
                    setFieldError('phone', getError('ERROR_INVALID_PHONE'));
                  } else {
                    setFieldError('phone', null);
                  }

                  state.phoneBlur = true;
                }
              "
            >
              <template v-slot:arrow-icon>
                <i class="bi bi-chevron-down" />
              </template>
              <template v-slot:icon-right>
                <i class="bi bi-telephone" />
              </template>
            </vue-tel-input>
          </div>
        </template>
      </VForm>
    </div>
    <div v-else class="view">
      <img src="@/assets/images/illustration/code-lock.svg" alt="Code" />
      <div class="block">
        <h2>Entrez le code reçu</h2>
        <p>
          Pour continuer, veuillez renseigner le code que vous avez reçu par
          message au
          <span
            class="primary-color semibold"
            v-text="state.phone_number.formatted"
          />
        </p>
      </div>
      <CodeConfirmation
        :isLoading="state.isLoading"
        @validation="confirmCode"
        @back="state.verification_id = null"
      />
    </div>
  </transition>
</template>

<script setup>
import { reactive } from "vue";
import { getError } from "@/composables/error.js";
import { useCandidateStore } from "@/stores/candidate.js";
import { useToast } from "vue-toastification";

const emits = defineEmits(["verified"]);

const candidateStore = useCandidateStore();

const toast = useToast();

defineProps({
  title: {
    type: String,
  },
  text: {
    type: String,
  },
  displayIcon: {
    type: Boolean,
    default: false,
  },
});

const state = reactive({
  phone_number: {
    formatted: null,
  },
  isLoading: false,
});

function formatNumber(formattedNumber, phoneObject) {
  state.phone_number = phoneObject;
  state.isValid = phoneObject.valid || false;
}

async function sendSMS() {
  state.isLoading = true;

  state.verification_id = await candidateStore.getPhoneVerificationToken(
    state.phone_number.number
  );

  if (!state.verification_id) {
    toast.error(
      "Une erreur s'est produite durant la création de votre compte. Veuillez vous rapprocher du support pour plus d'informations"
    );
  }

  state.isLoading = false;
}

async function confirmCode(code) {
  state.isLoading = true;

  const resp = await candidateStore.phoneVerification(
    state.phone_number.number,
    state.verification_id,
    code
  );

  if (resp.verification_id) {
    emits("verified", {
      phone: state.phone_number.number,
      verification_id: state.verification_id,
    });
  } else {
    toast.error(
      "Code de confirmation incorrect, veuillez vérifier le code renseigné."
    );
  }

  state.isLoading = false;
}
</script>
